// @ts-nocheck -- staged migration: add explicit types before removing this directive.
// Reads Japanese text aloud using the browser's built-in Web Speech API —
// free, key-less, and entirely client-side, unlike a hosted TTS API.
export function isSpeechSupported() {
    return typeof window !== "undefined" && "speechSynthesis" in window;
}

// Strips the okurigana "." boundary and leading "-" suffix marker used in
// KANJIDIC-style readings (e.g. "い.く", "-ゆき") so the browser reads the
// actual word instead of the notation.
export function cleanReadingForSpeech(reading) {
    return String(reading || "").replace(/[.-]/g, "");
}

// Default browser rate is 1 (normal speed). Used for a "slow" playback option
// so learners can hear a word's individual mora more clearly.
export const SLOW_SPEECH_RATE = 0.6;

export function hasOfflineJapaneseVoice() {
    return Boolean(isSpeechSupported() && window.speechSynthesis.getVoices?.().some(voice => /^ja(?:-|$)/i.test(voice.lang) && voice.localService));
}

export function speakJapanese(text, { rate = 1, onError } = {}) {
    if (!isSpeechSupported() || !text) return false;
    const offline = navigator.onLine === false;
    const voice = offline ? window.speechSynthesis.getVoices?.().find(voice => /^ja(?:-|$)/i.test(voice.lang) && voice.localService) : undefined;
    if (offline && !voice) return false;
    try {
        window.speechSynthesis.cancel();
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.lang = "ja-JP";
        if (voice) utterance.voice = voice;
        utterance.rate = rate;
        utterance.onerror = () => onError?.();
        window.speechSynthesis.speak(utterance);
        return true;
    } catch (_error) {
        return false;
    }
}
